import React, {Component} from 'react';

class ContactForm extends Component {
	constructor() {
		super();
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit(event) {
		/* Avoid page reload */
		event.preventDefault();

		/* Better use props or state */
		const form = event.target;
		const elements = form.elements;

		const spam = elements["spam"].value;
		const name = elements["name"].value;
		const mail = elements["mail"].value;
		const msg  = elements["msg"].value;

		if(!spam)
      		{
			/* Build fetch ajax request */
			const url = new URL("https://script.google.com/macros/s/AKfycbxPJVti72ODTcOGo2GvrHeY28xd44hUoZ7uGIYQz5gSo6E2O7OC/exec")
			const params = { "name": name, "email": mail, "message": msg }
			Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

			/* Ajax call */
			fetch(url, {crossDomain: true, method: 'post'});
		}
	}

	render() {
		return (
			<form className="box" onSubmit={this.handleSubmit}>
				{/* Spam assasin */}
				<div className="field is-hidden">
					<input id="spam" className="input" type="text" />
				</div>

				{/* Nombre input */}
				<div className="field">
					<label className="label">Nombre</label>
					<div className="control has-icons-left">
						<input id="name" className="input" type="text" placeholder="e.g. Alex Johnson" required/>
						<span className="icon is-small is-left">
							<i className="fa fa-user"></i>
						</span>
					</div>
				</div>

				{/* Email input */}
				<div className="field">
					<label className="label">Email</label>
					<div className="control has-icons-left">
						<input id="mail" className="input" type="email" placeholder="e.g. alexjohnson@gmail.com" required />
						<span className="icon is-small is-left">
							<i className="fa fa-envelope"></i>
						</span>
					</div>
				</div>

				{/* Text input */}
				<div className="field">
					<label className="label">Mensaje</label>
					<div className="control">
						<textarea id="msg" className="textarea" required />
					</div>
				</div>

				{/* Send button */}
				<div className="field">
					<button className="button is-success">
						Enviar
					</button>
				</div>
			</form>
		);
	}
}

export default ContactForm;




// WEBPACK FOOTER //
// ./src/components/Contact/ContactForm.js